// extracted by mini-css-extract-plugin
export var internalNoteEditor = "_hv-1";
export var quotedThread = "_hv-0";